module.exports = __webpack_public_path__ + "img/newsImg11-5.e301a659.png";